const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotarinIconFamilie(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 512 568",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-41.7703,-1314.92)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,1303.82)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Familie"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.753,566.533L250.753,499.632",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,102.855,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.753,566.533L250.753,499.632",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.16459,0,0,1.11511,-51.4307,-56.6732)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M379.998,499.224L379.998,569.57L220.667,569.57L220.667,499.224C220.667,469.837 243.477,446.014 271.615,446.014L329.049,446.014C357.187,446.014 379.998,469.837 379.998,499.224ZM365.483,499.224C365.483,478.209 349.171,461.173 329.049,461.173L271.615,461.173C251.493,461.173 235.181,478.209 235.181,499.224L235.181,554.411C235.181,554.411 365.483,554.411 365.483,554.411L365.483,499.224Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1.66663,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,327.704C327.918,327.704 350.584,350.37 350.584,378.288C350.584,406.206 327.918,428.872 300,428.872C272.082,428.872 249.416,406.206 249.416,378.288C249.416,350.37 272.082,327.704 300,327.704ZM300,344.608C281.411,344.608 266.32,359.699 266.32,378.288C266.32,396.876 281.411,411.968 300,411.968C318.589,411.968 333.68,396.876 333.68,378.288C333.68,359.699 318.589,344.608 300,344.608Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29603,0,0,1.29603,-192.536,-282.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.753,566.533L250.753,499.632",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "13.04px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.40777,0,0,1.34796,-230.683,-307.035)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M365.903,457.494C361.901,454.117 349.891,446.014 344.839,446.014L259.978,446.014C238.267,446.014 220.667,464.395 220.667,487.07L220.667,569.57L307.914,569.57",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "12.27px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.29603,0,0,1.29603,-194.696,-282.97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,327.704C327.918,327.704 350.584,350.37 350.584,378.288C350.584,406.206 327.918,428.872 300,428.872C272.082,428.872 249.416,406.206 249.416,378.288C249.416,350.37 272.082,327.704 300,327.704ZM300,340.747C279.281,340.747 262.459,357.568 262.459,378.288C262.459,399.007 279.281,415.829 300,415.829C320.719,415.829 337.541,399.007 337.541,378.288C337.541,357.568 320.719,340.747 300,340.747Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.15891,0,0,1.15891,775.033,-144.948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.753,566.533L250.753,499.632",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "14.59px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.25883,0,0,1.20535,809.144,-166.467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M344.839,446.014L259.978,446.014C238.267,446.014 220.667,464.395 220.667,487.07L220.667,569.57L307.914,569.57",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "13.72px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1.15891,0,0,1.15891,776.964,-144.948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300,327.704C272.082,327.704 249.416,350.37 249.416,378.288C249.416,406.206 272.082,428.872 300,428.872C327.918,428.872 350.584,406.206 350.584,378.288C350.584,350.37 327.918,327.704 300,327.704ZM300,342.29C319.868,342.29 335.998,358.42 335.998,378.288C335.998,398.156 319.868,414.286 300,414.286C280.132,414.286 264.002,398.156 264.002,378.288C264.002,358.42 280.132,342.29 300,342.29Z",
    style: {
      fill: "rgb(98,102,87)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.222,169.778L300,47.111L391.111,94.513",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.778,128.691L544.444,168.889",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.9px"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.06897,0,0,1,-32.3984,0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.971,128.691L466.971,19.556L396.186,19.556L396.186,90.508",
    style: {
      fill: "none",
      stroke: "rgb(98,102,87)",
      strokeWidth: "16.33px"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotarinIconFamilie);
export default __webpack_public_path__ + "static/media/Notarin_Icon_Familie.3de486af54415eddcc1925111c92c3b1.svg";
export { ForwardRef as ReactComponent };